module.exports = __webpack_public_path__ + "static/media/mreavesxlsannaru-020415006EmigreWebOnly.384751e6.eot";